import * as React from "react";
import { Ref, SVGProps, forwardRef } from "react";
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    ref={ref}
    className="social-icon"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        className="primary-path"
        fill="#111"
        fillOpacity={0.44}
        d="M23.522 6.686A3.016 3.016 0 0 0 21.4 4.55c-1.876-.504-9.376-.504-9.376-.504s-7.5 0-9.376.504A3.016 3.016 0 0 0 .526 6.686C.024 8.57.024 12.5.024 12.5s0 3.93.502 5.815a3.016 3.016 0 0 0 2.122 2.135c1.876.505 9.376.505 9.376.505s7.5 0 9.376-.505a3.015 3.015 0 0 0 2.122-2.135c.502-1.885.502-5.815.502-5.815s0-3.93-.502-5.814Z"
      />
      <path fill="#FEFEFE" d="M9.57 16.069V8.932l6.272 3.568L9.57 16.07Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .5h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
